import type { EBottomBarItem } from "../models/bottomBar.model";
import { BottomBarItemNavigator, BottomBarItemModal } from "./BottomBarItem";

export class BottomBarController {
  private items: (BottomBarItemModal | BottomBarItemNavigator)[] = [];

  public setItems(items: (BottomBarItemModal | BottomBarItemNavigator)[]) {
    this.items = items;
  }

  public handleClick(item: BottomBarItemModal | BottomBarItemNavigator) {
    this.closeBottomBarPopups({ except: item.name });
    item.navigate();
  }

  public get activeModalName() {
    return this.items.find(item => item instanceof BottomBarItemModal && item.isActive())?.name;
  }

  public get activeNavigatorName() {
    return this.items.find(item => item instanceof BottomBarItemNavigator && item.isActive())?.name;
  }

  public get activeItemName() {
    return this.activeModalName || this.activeNavigatorName;
  }

  public closeBottomBarPopups({ except }: { except?: EBottomBarItem } = {}) {
    this.items.forEach(item => {
      if (item instanceof BottomBarItemModal && item.name !== except) {
        item.closePopup();
      }
    })
  }

  public getItems() {
    return this.items;
  }

  public findPopupByHash(hash: string) {
    return this.items.find(item => item instanceof BottomBarItemModal && item.name === hash.slice(1));
  }

  public openModalByHash(hash: string) {
    const item = this.findPopupByHash(hash);
    if (item instanceof BottomBarItemModal) {
      item.openPopup();
    }
  }
}